import { templateChallengeEntriesPublic } from "./challenge-entries-public";
import { templateChallengeEntries } from "./challenge-entries";
import { templateChallengeSubmit } from "./challenge-submit";
import { templateChallengesListing } from "./challenges-listing";
import { templateHome } from "./home";
import { templateLandingCopy } from "./landing-copy";
import { templateLandingV2 } from "./landing-v2";
import { templateLanding } from "./landing";
import { templateMadeItForRecipe } from "./made-it-for-recipe";
import { templateMadeItHub } from "./made-it-hub";
import { templatePostDetail } from "./post-detail";
import { templatePostSubmit } from "./post-submit";
import { templatePrelaunch } from "./prelaunch";
import { templateProfileOther } from "./profile-other";
import { templateProfile } from "./profile";

export const NEMONTO_TEMPLATE_MAP = {
  "challenge-entries": {
    label: "Challenge Entries",
    html: templateChallengeEntries,
  },
  "challenge-entries-public": {
    label: "Challenge Entries Public",
    html: templateChallengeEntriesPublic,
  },
  "challenges-listing": {
    label: "Challenges Listing",
    html: templateChallengesListing,
  },
  "challenge-submit": {
    label: "Challenge Submit",
    html: templateChallengeSubmit,
  },
  "home": {
    label: "Home",
    html: templateHome,
  },
  "landing": {
    label: "Landing",
    html: templateLanding,
  },
  "landing-v2": {
    label: "Landing V2",
    html: templateLandingV2,
  },
  "landing-copy": {
    label: "Landing Copy",
    html: templateLandingCopy,
  },
  "made-it-for-recipe": {
    label: "Made It For Recipe",
    html: templateMadeItForRecipe,
  },
  "made-it-hub": {
    label: "Made It Hub",
    html: templateMadeItHub,
  },
  "post-detail": {
    label: "Post Detail",
    html: templatePostDetail,
  },
  "post-submit": {
    label: "Post Submit",
    html: templatePostSubmit,
  },
  "prelaunch": {
    label: "Prelaunch",
    html: templatePrelaunch,
  },
  "profile": {
    label: "Profile",
    html: templateProfile,
  },
  "profile-other": {
    label: "Profile Other",
    html: templateProfileOther,
  },
};

export const NEMONTO_PAGE_KEYS = Object.keys(NEMONTO_TEMPLATE_MAP);
